import React from 'react'
import prettysize from '../../../utils'
import { Popconfirm, Button, Icon, Checkbox } from 'antd'
import './styles.scss'

export default ({file, on_delete, on_upload, on_navigate, on_select }) => {
  console.log("efbefhkru ifhiroefhoirefj  ifjhieorj ierj");
  const {name, path, size, isFile, isDirectory} = file
  return (
    <a className='file-item columnWrap' onDoubleClick={()=> isDirectory && on_navigate(file)}>

      { isFile ? <Icon type="file-text"/> : <Icon type="folder" />}

      <span>{name}</span>

      {
        isFile ?
          <div className={'cmds'}>
            <span className='size'>{prettysize(size)}</span>
            <Checkbox checked={file.checked} onChange={(e)=> on_select(file, e.target.checked)}/>
            <Popconfirm title={'Are you sure to delete ' + name + ' ?'} placement="top" okText="Yes" cancelText="No" onConfirm={()=> on_delete(file)}>
              <Button icon="delete" size={'small'}/>
            </Popconfirm>
            <Button icon="upload" size={'small'} onClick={()=> on_upload([file])}/>
          </div> : null
      }
    </a>
  )
}
